import React from 'react';
import { Link } from 'react-router';
import config from "../../../config";

class ContactUsCallouts extends React.Component {
	handleClick(e) {
		global.dataLayer.push({
			event: 'Contact Us',
			eventCategory: 'Support',
			eventAction: e.currentTarget.textContent,
			eventLabel: global.location.pathname
		});
	}

	render() {
		return (
			<div className="contact-us-callouts">
				<div className="row">
					<div className="col sm-4">
						<a
							className="contact-us-callout"
							href={config.contactUsUSUrl}
							onClick={ e => this.handleClick(e) }
						>
							<img
								src={ require('../../../resources/img/icons/contact-us-red-icon.png') }
								srcSet={ `${require('../../../resources/img/icons/contact-us-red-icon@2x.png')} 2x` }
								alt="Contact Us"
							/>
							<p className="arrow-link">
								Contact Us - US / CA
							</p>
						</a>
					</div>
					<div className="col sm-4">
						<Link
							className="contact-us-callout"
							to="/support/contact-us/united-kingdom"
							onClick={ e => this.handleClick(e) }
						>
							<img
								src={ require('../../../resources/img/icons/contact-us-red-icon.png') }
								srcSet={ `${require('../../../resources/img/icons/contact-us-red-icon@2x.png')} 2x` }
								alt="Contact Us"
							/>
							<p className="arrow-link">
								Contact Us - UK
							</p>
						</Link>
					</div>
					<div className="col sm-4">
						<Link
							className="contact-us-callout"
							to="/support/contact-us/australia"
							onClick={ e => this.handleClick(e) }
						>
							<div>
								<img
									src={ require('../../../resources/img/icons/contact-us-red-icon.png') }
									srcSet={ `${require('../../../resources/img/icons/contact-us-red-icon@2x.png')} 2x` }
									alt="Contact Us"
								/>
							</div>
							<p className="arrow-link">
								Contact Us - AU
							</p>
						</Link>
					</div>
				</div>
			</div>
		);
	}
};

export default ContactUsCallouts;


// WEBPACK FOOTER //
// ./src/pages/support/contactUs/ContactUsCallouts.js